import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "./SectionTitle";

const MISSION_ITEMS = ["mission.item1", "mission.item2", "mission.item3", "mission.item4", "mission.item5"];
const VISION_ITEMS = ["vision.item1", "vision.item2", "vision.item3", "vision.item4", "vision.item5"];

function Card({ chipKey, headingKey, items, t }) {
  return (
    <Fade triggerOnce direction="up" duration={700} className="flex-1">
      <div className="bg-[#f8faff] border border-[#eaeaea] rounded-[24px] p-[25px] lg:p-[40px] flex flex-col gap-[20px] h-full">
        <div className="bg-white inline-flex items-center self-start px-[12px] py-[8px] rounded-full">
          <span className="font-['Inter'] font-bold text-[12px] tracking-[1.44px] uppercase text-[#1c385f]">
            {t(chipKey)}
          </span>
        </div>
        <p className="font-28-18">{t(headingKey)}</p>
        <div className="flex flex-col gap-[14px]">
          {items.map((key) => (
            <div key={key} className="flex items-start gap-[12px]">
              <span className="font-['Inter'] font-bold text-[16px] text-[#4da6ff] leading-[1.3]">✓</span>
              <p className="font-16-14 flex-1">{t(key)}</p>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}

function MissionVision() {
  const { t } = useTranslation();
  const [active, setActive] = useState("mission");

  const tabs = [
    { id: "mission", labelKey: "mission.chip" },
    { id: "vision", labelKey: "vision.chip" },
  ];

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="hidden sm:block">
          <SectionTitle
            title1={t("mission.title1")}
            title2={t("mission.title2")}
            text={t("mission.subtitle")}
            className="mx-auto mb-[40px]"
          />
        </div>
        <div className="sm:hidden">
          <SectionTitle
            title1={t("mission.title1")}
            title2={t("mission.title2")}
            text={t("mission.subtitle")}
            align="left"
            className="mb-[25px]"
          />
        </div>

        {/* Мобильный переключатель Mission / Vision */}
        <div className="sm:hidden flex gap-[16px] mb-[25px]">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className={`flex items-center px-[14px] py-[6px] rounded-full border border-[#1c385f] font-['Inter'] font-normal text-[14px] uppercase text-[#1c385f] transition-colors ${
                active === tab.id ? "bg-[#bfccd7]" : ""
              }`}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </div>

        {/* Desktop: обе карточки, mobile: активная */}
        <div className="flex gap-[24px]">
          <div className={`flex-1 ${active === "mission" ? "flex" : "hidden"} sm:flex`}>
            <Card chipKey="mission.chip" headingKey="mission.heading" items={MISSION_ITEMS} t={t} />
          </div>
          <div className={`flex-1 ${active === "vision" ? "flex" : "hidden"} sm:flex`}>
            <Card chipKey="vision.chip" headingKey="vision.heading" items={VISION_ITEMS} t={t} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
